/* Copyright (c) 2018 Verge Technologies
 * @file routes.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

import React, { Component } from 'react';
import { Router, Route, Redirect } from 'react-router-dom';
import { Switch } from 'react-router';
import uuid from 'uuid';
import qs from 'qs';
import {
  HomePage,
  ServicesPage,
  LaboratoryServicesPage,
  TechnicalSupportPage,
  ProductsPage,
  ProductPage,
  SpecialsPage,
  CareersPage,
  EventsPage,
  ArticlesPage,
  ArticlePage,
  AboutPage,
  TermsPage,
  PrivacyPage,
  ContactPage,
  FavouritesPage,
  RequestQuotePage,
  ThankYouPage,
  NoMatchPage,
} from './pages';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';
import GDPR from './components/GDPR/GDPR';

const trackingId = 'UA-154739233-1';

const generateUUID = () => {
  const id = uuid();
  localStorage.setItem('userId', id);
  return id;
}

ReactGA.initialize(trackingId);

ReactGA.set({
  userId: localStorage.getItem('userId') || generateUUID(),
});

const history = createBrowserHistory();

history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

// eslint-disable-next-line react/prefer-stateless-function
class Routes extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div style={{ width: '100vw', overflowX: 'auto' }}>
        <Router history={history}>
          <Switch>
            <Route
              exact
              path="/"
              component={() => <HomePage crumbs={[{ title: 'Separations', link: '/' }]} />}
            />
            <Route
              exact
              path="/services_support"
              component={() => <ServicesPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Services & Support', link: '/services_support' }]} />}
            />
            <Route
              exact
              path="/services_support/services"
              component={() =>
                (<LaboratoryServicesPage
                  crumbs={[
                    { title: 'Separations', link: '/' },
                    { title: 'Services & Support', link: '/services_support' },
                    { title: 'Services', link: '/services_support/services_support' },
                  ]}
                />)
              }
            />
            <Route
              exact
              path="/services_support/applications"
              component={() =>
                (<TechnicalSupportPage
                  crumbs={[
                    { title: 'Separations', link: '/' },
                    { title: 'Services & Support', link: '/services_support' },
                    { title: 'Applications', link: '/services_support/applications' },
                  ]}
                />)
              }
            />
            <Route
              exact
              path="/products"
              component={(props) => {
                const location = props.location.search;
                const application = location === '?applications'
                let brand = location === '?brands'
                const queryValue = qs.parse(props.location.search, { ignoreQueryPrefix: true });
                return (
                  <ProductsPage
                    filter={queryValue}
                    application={application}
                    brand={brand}
                    crumbs={[{ title: 'Separations', link: '/' },
                    { title: 'Products', link: '/products' }]}
                  />
                );
              }}
            />
            <Route
              exact
              path="/product/:slug"
              component={(props) => {
                return (
                  <ProductPage
                    slug={props.match.params.slug}
                    crumbs={[
                      { title: 'Separations', link: '/' },
                      { title: 'Products', link: '/products' },
                      { title: props.match.params.slug.replace(/-/g, ' '), link: props.match.params.slug }]}
                  />
                );
              }}
            />
            <Route
              exact
              path="/specials"
              component={() => <SpecialsPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Specials', link: '/specials' }]} />}
            />
            <Route
              exact
              path="/careers"
              component={() => <CareersPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Careers', link: '/careers' }]} />}
            />   
            <Route
              exact
              path="/events"
              component={() => <EventsPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Events', link: '/events' }]} />}
            />   

            <Route
              exact
              path="/favourites"
              component={() => <FavouritesPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Favourites', link: '/favourites' }]} client={this.props.client} />}
            />

            <Route
              exact
              path="/favourites/request-quote"
              component={(props) => {
                // Do not allow access to the request quote page if no props have been passed down
                if (props.location.state === undefined || props.location.state.favourites === undefined || props.location.state.favourites === null) {
                  return <Redirect to={{ pathname: '/favourites' }} />;
                }
                return (
                  <RequestQuotePage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Favourites', link: '/favourites' }, { title: 'Request Quote', link: '/favourites/request-quote' }]} favourites={props.location.state.favourites} />
                );
              }}
            />
            <Route
              exact
              path="/favourites/request-quote/thank-you"
              component={() => <ThankYouPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Favourites', link: '/favourites' }, { title: 'Request Quote', link: '/favourites/request-quote' }, { title: 'Thank You', link: '/favourites/request-quote/thank-you' }]} />}
            />
            <Route
              exact
              path="/articles"
              component={() => <ArticlesPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Articles', link: '/articles' }]} />}
            />
            <Route
              exact
              path="/articles/:slug"
              component={(props) => {
                return (
                  <ArticlePage
                    slug={props.match.params.slug}
                    crumbs={[
                      { title: 'Separations', link: '/' },
                      { title: 'Articles', link: '/articles' },
                      { title: props.match.params.slug.replace(/-/g, ' '), link: props.match.params.slug }]}
                  />
                );
              }}
            />
            <Route
              exact
              path="/about"
              component={() => <AboutPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'About', link: '/about' }]} />}
            />
            <Route
              exact
              path="/terms"
              component={() => <TermsPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Terms & Conditions', link: '/terms' }]} />}
            />
            <Route
              exact
              path="/privacy"
              component={() => <PrivacyPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Privacy', link: '/privacy' }]} />}
            />            
            <Route
              exact
              path="/contactus"
              component={() => <ContactPage crumbs={[{ title: 'Separations', link: '/' }, { title: 'Contact Us', link: '/contactus' }]} />}
            />
            <Route
              component={NoMatchPage}
            />
          </Switch>
        </Router>
        <GDPR />
      </div>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js